import getConstants from '@/shared/constants';
import { getVars as getEnvVars } from '@/shared/constants/envVars';

import { EntityBaseApiService, getEntityApiBase } from './client';

const constants = getConstants();
const { isModeDevelopment } = constants;

const envVars = getEnvVars();
const apiSettings = JSON.parse(envVars.VITE_API_SETTINGS);

EntityBaseApiService.registerGetEntityApiBase(entityName =>
  getEntityApiBase({
    apiSettings,
    basePath: '/api',
    isRequestUrlPure: !isModeDevelopment,
    target: self.location.origin,
    entityName,
    usingProxy: isModeDevelopment,
  })
);
EntityBaseApiService.setAppBasePath(constants.appBasePath);
